/* Favorites without an account: a list of product handles in localStorage. */
(function () {
  var KEY = 'ms:favorites';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* storage unavailable */ }
  }

  function sync() {
    var list = read();

    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.favHandle) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    document.querySelectorAll('[data-fav-count]').forEach(function (badge) {
      badge.textContent = list.length;
      badge.hidden = list.length === 0;
    });

    document.dispatchEvent(new CustomEvent('favorites:change', { detail: { handles: list } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fav-toggle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.favHandle;
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    sync();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });

  // Cards re-render (filters, recommendations), so re-sync when new toggles appear.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType === 1 && (node.matches('[data-fav-toggle]') || node.querySelector('[data-fav-toggle]'))) {
          sync();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---- /pages/favorites -------------------------------------------------
  function initPage(root) {
    var grid = root.querySelector('[data-favorites-grid]');
    var empty = root.querySelector('[data-favorites-empty]');
    var count = root.querySelector('[data-favorites-count]');
    var addAll = root.querySelector('[data-favorites-add-all]');
    var message = root.querySelector('[data-favorites-message]');
    var items = {}; // handle -> <li>

    function say(text) {
      message.textContent = text || '';
      message.hidden = !text;
    }

    function refresh() {
      var shown = grid.querySelectorAll('[data-fav-card]').length;
      var pending = grid.children.length;
      empty.hidden = pending > 0;
      count.hidden = pending === 0;
      count.textContent = '(' + pending + (pending === 1 ? ' product)' : ' products)');
      var available = grid.querySelectorAll('[data-fav-card][data-available="true"]').length;
      addAll.hidden = shown === 0;
      addAll.setAttribute('aria-disabled', available === 0 ? 'true' : 'false');
    }

    function load(handle) {
      var li = document.createElement('li');
      li.dataset.handle = handle;
      grid.appendChild(li);
      items[handle] = li;

      fetch('/products/' + encodeURIComponent(handle) + '?view=card', { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          li.innerHTML = html;
          refresh();
          sync();
        })
        .catch(function () {
          // The product no longer exists: drop it from the saved list.
          write(read().filter(function (h) { return h !== handle; }));
          li.remove();
          delete items[handle];
          refresh();
          sync();
        });
    }

    function reconcile() {
      var list = read();
      Object.keys(items).forEach(function (handle) {
        if (list.indexOf(handle) === -1) {
          items[handle].remove();
          delete items[handle];
        }
      });
      list.forEach(function (handle) {
        if (!items[handle]) load(handle);
      });
      refresh();
    }

    addAll.addEventListener('click', function () {
      if (addAll.getAttribute('aria-disabled') === 'true') return;
      var lines = [];
      grid.querySelectorAll('[data-fav-card][data-available="true"]').forEach(function (card) {
        lines.push({ id: Number(card.dataset.variantId), quantity: 1 });
      });
      if (!lines.length) return;

      addAll.setAttribute('aria-disabled', 'true');
      say('');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          window.location.href = '/cart';
        })
        .catch(function () {
          addAll.setAttribute('aria-disabled', 'false');
          say('Some items could not be added to the cart. Please try again.');
        });
    });

    document.addEventListener('favorites:change', reconcile);
    reconcile();
  }

  function init() {
    sync();
    var page = document.querySelector('[data-favorites]');
    if (page) initPage(page);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
